import config from "@/utils/config"
let obj=config.context;

// let obj = "/v1"

export const  reqUrl = {
    add: obj+ "/{0}/add",
    del: obj+ "/{0}/delete?id={1}",
    edit: obj+ "/{0}/edit",
    page: obj+ "/{0}/page",
    delall: obj+ "/{0}/delete-batch?ids={1}",
    all: obj+ "/{0}/lists",
    getById: obj+ "/{0}/get-by-id/{1}",
    getType: obj+ "/busType/getBusType"
}

export const processReq={
    saveModel: obj+ '/model/service/model/{0}/save',//保存流程模板
    findModel: obj+ '/model/{0}/editor/json',
    serviceInstances: obj+ '/model/service-instances'
}
export const  flowbles = {
    getDep: obj + '/businessManagement/departmentManagement/all ',//查询部门
    getUser: obj + '/businessManagement/userManagement/findUserByDepId',//通过部门查人员
    process:obj + '/model/deploy-process',//部署流程
    busCodeProcess: obj + '	/processtemplate/bus-code',//流程业务编码


}
export const equipment={
    detailed:obj+"/equipsort/get-by-id/",
    process:obj + '/model/deploy-process',//部署流程
    pronsorDoPsge: obj + '/processinstance/sponsor-do-page',//我发起流程
    toDoPage: obj + '/processinstance/to-do-page', //待办流程
    executeTask: obj + '/processinstance/execute-task',//执行任务（处理流程)
    allProcess: obj + "/processinstance/all-page",//本单位所有流程
    havePage:obj + '/processinstance/have-do-page',//已办流程
    processStates: obj + '/processinstance/flowable-proces-states',//流程实例状态枚举
    processInstanceId: obj + '/processinstance/process-diagram/{0}/{1}',//流程图
    diagramBusSn: obj + '/api/v1.0/processinstance/process-diagram-bus-sn/{0}',//业务单号查看流程图
    getByBusSn: obj + '/api/v1.0/processinstance/get-by-bus-sn/{0}',//通过业务单据获取流程实例
}
